import { render, staticRenderFns } from "./DescargarDhl.vue?vue&type=template&id=79ef819f&"
import script from "./DescargarDhl.vue?vue&type=script&lang=js&"
export * from "./DescargarDhl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports